export default "__VITE_ASSET__6t7$ytTu__"